/* eslint-disable react/prop-types */
import React from 'react'
import { useTranslation } from 'react-i18next'

/* ANTD */
import Spin from 'antd/es/spin'

/* ANTD MOBILE */

import 'antd/dist/antd.css'
import 'antd-mobile/dist/antd-mobile.css'

const Waiting = (props) => {
  const { t } = useTranslation();
  return (
    <div className="element-spin-page" style={{ display: props.show ? '' : 'none', height: window.document.body.scrollHeight }} >
      <div className='element-spin-content'>
        <Spin size='large' tip={`[${t('common.wait')}...]`}></Spin>
      </div>
    </div>
  )
}

export default Waiting
